import React from 'react';
import { NavLink } from 'react-router-dom';
import * as Action from 'store/_actions';
import { helper, images } from 'utils';
import * as $ from 'jquery';

const NavigationLinks = (props) => {
	const closeHamburger = () => {
		$('#hamburger-menu').addClass('hide');
	};
	return (
		<React.Fragment>
			<ul className="nav flex-column">
				{props?.auth?.userData?.type === 'admin' ? (
					<div>
						<li className="py-4 border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/dashboard"
								onClick={closeHamburger}
							>
								<i className="mr-3 fa fa-cubes" alt="icon" /> Overview
							</NavLink>
						</li>
						<li className="py-4 border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/users"
								onClick={closeHamburger}
							>
								<i className="mr-3 fa fa-users" alt="icon" /> Accounts
							</NavLink>
						</li>
						<li className=" py-4 border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/discounts"
								onClick={closeHamburger}
							>
								<i className="mr-3 fa fa-gift" alt="icon" /> Discounts
							</NavLink>
						</li>
						<li className=" py-4 border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/vouchers"
								onClick={closeHamburger}
							>
								<i className="mr-3 fa fa-gift" alt="icon" /> Vouchers
							</NavLink>
						</li>
						<li className=" py-4 border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/admin-settings"
								onClick={closeHamburger}
							>
								<i className="mr-3 fa fa-cog" alt="icon" /> Settings
							</NavLink>
						</li>
					</div>
				) : (
					<div>
						<li className="nav-link-dashboard border-bottom">
							<NavLink
								className="drawer-link transi"
								activeClassName="drawer-link-active"
								to="/stores"
								onClick={closeHamburger}
							>
								<img src={images.DashboardIcon} className="mr-2" alt="icon" />{' '}
								Overview
							</NavLink>
						</li>
						{helper.hasAccessTo('menus') && (
							<li className="border-bottom">
								<NavLink
									className="drawer-link transi"
									activeClassName="drawer-link-active"
									to="/menus"
									onClick={closeHamburger}
								>
									<i className="mr-2 fa fa-list-alt" alt="icon" /> Menus
								</NavLink>
							</li>
						)}
						{(helper.hasAccessTo('promotions') ||
							helper.hasAccessTo('vouchers')) && (
							<li className="border-bottom">
								<NavLink
									className="drawer-link transi"
									activeClassName="drawer-link-active"
									to="/discounts"
									onClick={closeHamburger}
								>
									<i className="mr-3 fa fa-gift" alt="icon" /> Discounts
								</NavLink>
							</li>
						)}
						{(helper.hasAccessTo('riders') || helper.hasAccessTo('people')) && (
							<li className="border-bottom">
								<NavLink
									className="drawer-link transi"
									activeClassName="drawer-link-active"
									to="/people"
									onClick={closeHamburger}
								>
									<i className="mr-2 fa fa-users" alt="icon" /> People
								</NavLink>
							</li>
						)}
						{helper.hasAccessTo('reports') && (
							<li className="border-bottom">
								<NavLink
									className="drawer-link transi"
									activeClassName="drawer-link-active"
									to="/reports"
									onClick={closeHamburger}
								>
									<i className="mr-2 fa fa-database" alt="icon" /> Reports
								</NavLink>
							</li>
						)}
						{helper.hasAccessTo('misc_map') && (
							<li className="border-bottom">
								<NavLink
									className="drawer-link transi"
									activeClassName="drawer-link-active"
									to="/map"
									onClick={closeHamburger}
								>
									<i className="mr-2 fa fa-globe" alt="icon" /> Map
								</NavLink>
							</li>
						)}
					</div>
				)}
				<li className="border-bottom">
					<NavLink
						className="drawer-link transi"
						activeClassName="drawer-link-active"
						to="/settings"
						onClick={closeHamburger}
					>
						<i className="mr-2 fa fa-cog" alt="icon" /> Settings
					</NavLink>
				</li>
				<li className="border-bottom">
					<NavLink
						className="drawer-link transi"
						activeClassName="drawer-link-active"
						to="/support"
						onClick={closeHamburger}
					>
						<i className="mr-2 fa fa-question-circle" alt="icon" /> Support
					</NavLink>
				</li>
				<li className="logout">
					<NavLink
						className="drawer-link transi"
						to="/"
						onClick={() => {
							props.dispatch(Action.userSignOut());
							closeHamburger();
						}}
					>
						<i className=" mr-3 fa fa-power-off" />
						Logout
					</NavLink>
				</li>
			</ul>
			<div
				className="text-white text-center mt-5"
				onClick={() => {
					caches.keys().then((keys) => {
						Promise.all(keys.map((key) => caches.delete(key))).then(() => {
							window.history.forward(1);
							window.location.reload(true);
						});
					});
				}}
			>
				v.{helper.app.version}
			</div>
		</React.Fragment>
	);
};

export default NavigationLinks;
